import {materialConnection} from "#material/nodes/base/connection/shorthand"
import type {InputMaterialConnection, OutputMaterialConnection} from "#material/sockets/definition"
import {Geometry} from "#material/nodes/converter/geometry/geometry"
import {normalize, vectorAdd, vectorMul, vectorSub} from "#material/nodes/converter/vector-math/shorthand"
import {SeparateHsv} from "#material/nodes/converter/separate-hsv/separate-hsv"
import {CombineHsv} from "#material/nodes/converter/combine-hsv/combine-hsv"
import {mathOp, sub} from "#material/nodes/converter/scalar-math/shorthands"

export function adjustWorldNormalStrength(worldNormal: InputMaterialConnection<"normal">, strength: InputMaterialConnection<"float"> | number) {
    if (strength === 1) {
        return worldNormal
    }
    const geomNormal = materialConnection(
        new Geometry({
            parameters: {
                inputs: {},
                settings: {},
            },
        }),
        "normal",
    )
    if (strength === 0) {
        return geomNormal
    }
    return normalize(vectorAdd(vectorMul(vectorSub(worldNormal, geomNormal), strength), geomNormal))
}

function rescaleAndClamp(
    value: InputMaterialConnection<"float">,
    minValue: InputMaterialConnection<"float"> | number,
    maxValue: InputMaterialConnection<"float"> | number,
): OutputMaterialConnection<"float"> {
    return mathOp("DIVIDE", sub(value, minValue), sub(maxValue, minValue), true)
}

export function rescaleColorValue(
    color: InputMaterialConnection<"color">,
    minValue: InputMaterialConnection<"float"> | number,
    maxValue: InputMaterialConnection<"float"> | number,
): OutputMaterialConnection<"color"> {
    const hsv = new SeparateHsv({
        parameters: {
            inputs: {
                image: color,
            },
            settings: {},
        },
    })
    return materialConnection(
        new CombineHsv({
            parameters: {
                inputs: {
                    h: materialConnection(hsv, "h"),
                    s: materialConnection(hsv, "s"),
                    v: rescaleAndClamp(materialConnection(hsv, "v"), minValue, maxValue),
                },
                settings: {},
            },
        }),
        "image",
    )
}
